import { queryClient } from '@/queries';
import { routePlannerQueries } from '@/queries/route-planner';

export const getLogisticsDataById = (logisticsId: string) => {
  const logisticsData = queryClient.getQueryData(routePlannerQueries.getLogisticsById(logisticsId).queryKey);

  if (!logisticsData) {
    throw new Error('No logistics data provided');
  }

  return logisticsData;
};
